import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgLockIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 24 24">
      <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.99997 11V7C6.99997 5.67392 7.52675 4.40215 8.46444 3.46447C9.40212 2.52678 10.6739 2 12 2C13.3261 2 14.5978 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  );
};

export default SvgLockIcon;
